import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const rlotChange: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldRlot' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [{ type: 'field', field: 'newRlot' }],
    },
];

export default rlotChange;
